
export default {
  props: {
    prefooterData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      stats: [],
    }
  },
  async fetch() {
    // if (this.$root.context.isDev) return
    return await this.$axios
      .get('https://v2-api.wellcertified.com/api/well/footer-stats')
      .then((res) => {
        const stats = res.data
        stats.sqftArea = stats.stat_area.split(' ')[0]
        stats.mArea = Math.floor((100 * stats.sqftArea) / 10.764)

        this.stats = this.formatPreFooter(stats)

        // set in store to be used elsewhere
        this.$store.commit('setStats', stats)
      })
      .catch((res) => {
        if (!res.response) {
          console.error('no res', res)
          this.stats = this.prefooterData
        }
      })
  },
  methods: {
    formatPreFooter(stats) {
      if (!stats) {
        // if no stats return preFooter data
        return this.prefooterData
      }

      // merge preFooter data with stats
      const statComp1 = { ...this.prefooterData[0] }
      const statComp2 = { ...this.prefooterData[1] }
      const statComp3 = { ...this.prefooterData[2] }

      statComp2.title_1 = statComp2.title_1.replace(
        '*',
        stats.stat_wellap_certified
      )
      statComp2.title_2 = statComp2.title_2.replace(
        '*',
        stats.stat_well_ap_registered
      )
      statComp2.details_1 = statComp2.details_1.replace('*', stats.stat_wellaps)
      statComp2.details_2 = statComp2.details_2.replace(
        '*',
        stats.stat_wellap_countries
      )

      statComp3.title_1 = statComp3.title_1.replace('*', stats.stat_certified)
      statComp3.title_2 = statComp3.title_2.replace('*', stats.stat_registered)
      statComp3.details_1 = statComp3.details_1.replace('*', stats.stat_area)
      statComp3.details_2 = statComp3.details_2.replace(
        '*',
        stats.stat_countries
      )

      return [statComp1, statComp2, statComp3]
    },
  },
}
